import styled from "styled-components";

import { colorsPalettes } from "@similarweb/styles";

// Inset divider under the "add as new" row; a pseudo-element can't be expressed with Box props.
export const StyledAddNewAttendeeWrapper = styled.div`
    position: relative;

    &:after {
        background-color: ${colorsPalettes.carbon["100"]};
        bottom: -1px;
        content: "";
        height: 1px;
        left: 8px;
        position: absolute;
        width: calc(100% - 16px);
    }
`;
